bq.global.runEllipsis = function () {
		var dotdotdot = function() {
      $('.ellipsis').dotdotdot({
        watch: true,
        tolerance: 1,
        callback: afterCompleted
      });
    };

      dotdotdot();
};

function afterCompleted(isTruncated) {
	if (($(this).hasClass('onepage-item-title') || $(this).data('bq') === 'popup-original-title') && !isTruncated) {
		$(this).popover('destroy');
	}
}

bq.init.push(bq.global.runEllipsis);